import { createTheme } from "@mui/material";

export const rippleEffect = createTheme({
  components: {
    MuiTouchRipple: {
      variants: [
        {
          props: { classes: "red" },
          style: {
            color: "red",
          },
        },
      ],
    },
  },
});
